module.exports = __webpack_public_path__ + "media/directory/likes_icon-22bd3530.svg";